import { format, addYears } from 'date-fns';
import { Product } from '../../app/model/product';
import {
    getContractNumber,
    getPartnerLogo,
} from '../../app/services/sci-rate.service';
import { isEmpty, isNil } from 'lodash-es';
import { QuoteStep } from '../../app/model/quote-step';

export class QuoteSubmission {
    public quoteSubmissionPayload = {
        ContactKey: 'qid_contactKey',
        EventDefinitionKey: '',
        emailType: 'agentQuoteSubmission',
        EstablishContactKey: true,
        Data: {
            EmailAddress: 'qid_contactKey',
            subjectline: 'qid_subjectLine',
            PartnerLogo: 'qid_logo',
            AgencyName: 'qid_agencyName',
            AgentEmail: 'qid_agentEmail',
            Flow: 'qid_flow',
            Mobile: 'qid_telNumber',
            ProducerCode: 'qid_producerCode',
            ProducerName: 'qid_producerName',
            InsuredName: 'qid_insuredName',
            Address: 'qid_address',
            COB: 'qid_businessType',
            Product1: 'qid_product1',
            YearlyPremiumProduct1: 'qid_premium1',
            QuoteNumber1: 'qid_quote1',
            MPQuoteID1: 'qid_quoteID1',
            EffectiveDate1: 'qid_effectiveDate1',
            WebpageURLProduct1: 'qid_productMP1',
            Product2: 'qid_product2',
            YearlyPremiumProduct2: 'qid_premium2',
            QuoteNumber2: 'qid_quote2',
            MPQuoteID2: 'qid_quoteID2',
            EffectiveDate2: 'qid_effectiveDate2',
            WebpageURLProduct2: 'qid_productMP2',
            Product3: 'qid_product3',
            YearlyPremiumProduct3: 'qid_premium3',
            QuoteNumber3: 'qid_quote3',
            MPQuoteID3: 'qid_quoteID3',
            EffectiveDate3: 'qid_effectiveDate3',
            WebpageURLProduct3: 'qid_productMP3',
            Product4: 'qid_product4',
            YearlyPremiumProduct4: 'qid_premium4',
            QuoteNumber4: 'qid_quote4',
            MPQuoteID4: 'qid_quoteID4',
            EffectiveDate4: 'qid_effectiveDate4',
            WebpageURLProduct4: 'qid_productMP4',
            Product5: 'qid_product5',
            YearlyPremiumProduct5: 'qid_premium5',
            QuoteNumber5: 'qid_quote5',
            MPQuoteID5: 'qid_quoteID5',
            EffectiveDate5: 'qid_effectiveDate5',
            WebpageURLProduct5: 'qid_productMP5',
            Product6: 'qid_product6',
            YearlyPremiumProduct6: 'qid_premium6',
            QuoteNumber6: 'qid_quote6',
            MPQuoteID6: 'qid_quoteID6',
            EffectiveDate6: 'qid_effectiveDate6',
            WebpageURLProduct6: 'qid_productMP6',
            Product7: 'qid_product7',
            YearlyPremiumProduct7: 'qid_premium7',
            QuoteNumber7: 'qid_quote7',
            MPQuoteID7: 'qid_quoteID7',
            EffectiveDate7: 'qid_effectiveDate7',
            WebpageURLProduct7: 'qid_productMP7',
            CoverageQuestion: 'qid_coverage',
            Comments: 'qid_comments',
            timestamp: 'qid_timestamp',
        },
    };

    // Build quote submission payload
    public buildQuoteSubmissionRequest(
        quoteSubmissionPayload: any,
        simpleQuestionsObj: any,
        products: any,
        partnerId: any,
        agentInfo: any,
        customerInfoData: any,
        referData: any,
        agentEmail: any,
        partnerNameForEmail: string,
        businessInfo: QuoteStep
    ) {
        let state: string;
        let primaryLoc: string;
        let zipcode: string;
        let city: string;
        if (simpleQuestionsObj && simpleQuestionsObj.length > 0) {
            simpleQuestionsObj.forEach((questionGroup) => {
                if (
                    questionGroup.group_name === 'Business Address' &&
                    questionGroup.questions &&
                    questionGroup.questions.length > 0
                ) {
                    questionGroup.questions.forEach((question) => {
                        if (
                            question.question_id === '6' &&
                            !isNil(question.value) &&
                            !isEmpty(question.value)
                        ) {
                            state = question.value;
                        }
                        if (
                            question.question_id === '7' &&
                            !isNil(question.value) &&
                            !isEmpty(question.value)
                        ) {
                            zipcode = question.value;
                        }
                        if (
                            question.question_id === '5' &&
                            !isNil(question.value) &&
                            !isEmpty(question.value)
                        ) {
                            city = question.value;
                        }
                        if (question.question_id === '4' && question.rawValue) {
                            primaryLoc = question.value;
                        }
                    });
                    primaryLoc =
                        primaryLoc + ',' + city + ',' + state + ',' + zipcode;
                }
            });
        }
        if (
            typeof quoteSubmissionPayload !== 'object' ||
            quoteSubmissionPayload === undefined ||
            products.length === 0
        ) {
            return;
        } else {
            for (const item in quoteSubmissionPayload) {
                if (
                    typeof quoteSubmissionPayload[item] === 'string' &&
                    quoteSubmissionPayload[item].includes('qid')
                ) {
                    if (
                        typeof simpleQuestionsObj[
                            quoteSubmissionPayload[item]
                        ] !== 'undefined'
                    ) {
                        quoteSubmissionPayload[item] =
                            simpleQuestionsObj[quoteSubmissionPayload[item]]
                                .value || '';
                    } else {
                        // Get the business name from the user answers
                        let businessName: any;
                        let effectiveDate: any;
                        simpleQuestionsObj.forEach((questionGroup) => {
                            if (
                                questionGroup.group_name ===
                                'Universal Questions'
                            ) {
                                questionGroup.questions.forEach((question) => {
                                    if (question.question_id === '1') {
                                        // Company name
                                        businessName = question.value;
                                    }
                                });
                            } else if (
                                questionGroup.group_name ===
                                'Coverage Start Date'
                            ) {
                                questionGroup.questions.forEach((question) => {
                                    effectiveDate = question.value;
                                });
                            }
                        });
                        // data from user answers
                        switch (quoteSubmissionPayload[item]) {
                            case 'qid_contactKey':
                                quoteSubmissionPayload[item] = agentEmail;
                                break;

                            case 'qid_subjectLine':
                                quoteSubmissionPayload[item] =
                                    'You have a new lead for ' +
                                    businessName +
                                    ' from ' +
                                    partnerNameForEmail +
                                    '!';
                                break;

                            case 'qid_logo':
                                quoteSubmissionPayload[item] =
                                    getPartnerLogo(partnerId);
                                break;

                            case 'qid_agencyName':
                                quoteSubmissionPayload[item] = '';
                                break;

                            case 'qid_producerName':
                                if (
                                    customerInfoData.firstName &&
                                    !isNil(customerInfoData.firstName) &&
                                    !isEmpty(customerInfoData.firstName)
                                ) {
                                    quoteSubmissionPayload[item] =
                                        customerInfoData.firstName +
                                        ' ' +
                                        customerInfoData.lastName;
                                } else {
                                    quoteSubmissionPayload[item] = '';
                                }
                                break;

                            case 'qid_flow':
                                quoteSubmissionPayload[item] = '';
                                break;

                            case 'qid_agentEmail':
                                quoteSubmissionPayload[item] =
                                    customerInfoData.emailAddress;
                                break;

                            case 'qid_telNumber':
                                quoteSubmissionPayload[item] =
                                    customerInfoData.phoneNumber;
                                break;

                            case 'qid_producerCode':
                                quoteSubmissionPayload[item] = '';
                                break;

                            case 'qid_insuredName':
                                quoteSubmissionPayload[item] = businessName;
                                break;

                            case 'qid_address':
                                quoteSubmissionPayload[item] = primaryLoc;
                                break;

                            case 'qid_businessType':
                                quoteSubmissionPayload[item] =
                                    businessInfo &&
                                    businessInfo.business &&
                                    businessInfo.business.value &&
                                    businessInfo.business.value.name
                                        ? businessInfo.business.value.name
                                        : '';
                                break;

                            case 'qid_coverage':
                                quoteSubmissionPayload[item] =
                                    referData &&
                                    referData.referReason &&
                                    referData.referReason.value
                                        ? referData.referReason.value
                                        : '';
                                break;

                            case 'qid_comments':
                                quoteSubmissionPayload[item] =
                                    referData &&
                                    referData.referExplaination &&
                                    referData.referExplaination.value
                                        ? referData.referExplaination.value
                                        : '';
                                break;

                            case 'qid_timestamp':
                                quoteSubmissionPayload[item] = format(
                                    new Date(),
                                    'MM/dd/yyyy h:mm:ss'
                                );
                                break;
                        }

                        // data from products selected
                        products.forEach((product: Product) => {
                            // Only send products that have been added to the cart
                            if (
                                product.selected ||
                                (product.productSourceSystem === 'SCI' &&
                                    parseInt(
                                        product.premium_amount.Premium,
                                        10
                                    ) > 0 &&
                                    product.productId !== 'UMBRELLA')
                            ) {
                                const seqOfProduct =
                                    products.indexOf(product) + 1;
                                switch (quoteSubmissionPayload[item]) {
                                    case 'qid_quote' + seqOfProduct: // quote numbers
                                        if (
                                            product.quote_number &&
                                            !isNil(product.quote_number) &&
                                            !isEmpty(product.quote_number)
                                        ) {
                                            quoteSubmissionPayload[item] =
                                                product.quote_number;
                                        }
                                        break;

                                    case 'qid_product' + seqOfProduct: // product name
                                        if (product.quote_number) {
                                            quoteSubmissionPayload[item] =
                                                product.name;
                                        }
                                        break;

                                    case 'qid_quoteID' + seqOfProduct: // product name
                                        if (product.quote_number) {
                                            quoteSubmissionPayload[item] =
                                                product.quoteID;
                                        }
                                        break;

                                    case 'qid_effectiveDate' + seqOfProduct: // product effective date:
                                        if (product.quote_number) {
                                            quoteSubmissionPayload[item] =
                                                effectiveDate;
                                        }
                                        break;

                                    case 'qid_productMP' + seqOfProduct: // Product web URL'S
                                        if (product.quote_number) {
                                            quoteSubmissionPayload[item] =
                                                product.mpWebUrl;
                                        }
                                        break;

                                    case 'qid_premium' + seqOfProduct: // yearly premium value
                                        if (
                                            product.quote_number &&
                                            product.errorMessage != null
                                        ) {
                                            if (
                                                product.productSourceSystem !==
                                                    'SCI' &&
                                                (product.errorMessage !==
                                                    'Referral' ||
                                                    product.errorMessage !==
                                                        'Declined' ||
                                                    product.errorMessage !==
                                                        'Decline')
                                            ) {
                                                if (product.selectedpackage) {
                                                    quoteSubmissionPayload[
                                                        item
                                                    ] = Number.parseFloat(
                                                        product.selectedpackage
                                                            .premiumAmount
                                                    ).toFixed(2);
                                                } else {
                                                    quoteSubmissionPayload[
                                                        item
                                                    ] = Number.parseFloat(
                                                        product
                                                            .productPackages[0]
                                                            .premiumAmount
                                                    ).toFixed(2);
                                                }
                                            } else if (
                                                product.premium_amount &&
                                                (product.errorMessage !==
                                                    'Referral' ||
                                                    product.errorMessage !==
                                                        'Declined' ||
                                                    product.errorMessage !==
                                                        'Decline')
                                            ) {
                                                quoteSubmissionPayload[item] =
                                                    '$' +
                                                    Number.parseFloat(
                                                        product.premium_amount
                                                            .Premium
                                                    ).toFixed(2) +
                                                    '/year';
                                            }
                                        }
                                        break;
                                }
                            }
                        });
                        // After parsing if any qid is found make it empty
                        if (
                            quoteSubmissionPayload[item] !== undefined &&
                            quoteSubmissionPayload[item] !== null &&
                            quoteSubmissionPayload[item]
                                .toString()
                                .includes('qid')
                        ) {
                            quoteSubmissionPayload[item] = '';
                        }
                    }
                } else if (typeof quoteSubmissionPayload[item] === 'object') {
                    if (Array.isArray(quoteSubmissionPayload[item])) {
                        for (
                            let j = 0;
                            j < quoteSubmissionPayload[item].length;
                            j++
                        ) {
                            this.buildQuoteSubmissionRequest(
                                quoteSubmissionPayload[item][j],
                                simpleQuestionsObj,
                                products,
                                partnerId,
                                agentInfo,
                                customerInfoData,
                                referData,
                                agentEmail,
                                partnerNameForEmail,
                                businessInfo
                            );
                        }
                    } else {
                        if (
                            Object.keys(quoteSubmissionPayload[item]).length !==
                            0
                        ) {
                            this.buildQuoteSubmissionRequest(
                                quoteSubmissionPayload[item],
                                simpleQuestionsObj,
                                products,
                                partnerId,
                                agentInfo,
                                customerInfoData,
                                referData,
                                agentEmail,
                                partnerNameForEmail,
                                businessInfo
                            );
                        }
                    }
                }
            }
        }
        return quoteSubmissionPayload;
    }
}
